import store from "../store/store";

export default class BaseService {
  realm() {
    return store.getState().user.stitchUser;
  }
}
